import { Reveal } from "./Reveal";

const stats = [
  { value: "$107K+", label: "Potential annual revenue per bay" },
  { value: "35+", label: "Sports & activities" },
  { value: "24/7", label: "Automated operations" },
];

export default function StatsBand() {
  return (
    <section id="numbers" data-testid="stats-band" className="border-y border-white/10 bg-[#0A0A12]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-3">
        {stats.map((s, i) => (
          <Reveal
            key={s.value}
            delay={i * 0.08}
            className={`p-10 md:p-14 ${i !== stats.length - 1 ? "sm:border-r border-b sm:border-b-0 border-white/[0.06]" : ""}`}
          >
            <div data-testid={`stat-value-${i}`} className="font-heading font-extrabold tracking-tighter text-4xl md:text-6xl text-white">
              {s.value}
            </div>
            <div className="mt-3 font-mono-pv text-[11px] uppercase tracking-[0.15em] text-white/40 leading-relaxed">
              {s.label}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
